import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { verifyEmail } from '../services/api';
import { LINKS } from '../constants/links';

export default function VerifyEmail() {
  const [search] = useSearchParams();
  const token = search.get('token') || '';
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    (async () => {
      try {
        if (!token) throw new Error('Missing token');
        await verifyEmail(token);
        setStatus('ok');
        setMessage('Your email has been confirmed. You can now sign in.');
      } catch (e: any) {
        setStatus('error');
        setMessage(e?.message || 'Verification failed.');
      }
    })();
  }, [token]);

  return (
    <div className="flex justify-center bg-gray-100 dark:bg-neutral-900 px-4 py-24">
      <div className="bg-white dark:bg-neutral-800 p-8 rounded-lg shadow-lg w-full max-w-sm text-center">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">
          Email Verification
        </h2>
        <p
          className={
            status === 'error'
              ? 'text-red-600'
              : 'text-gray-700 dark:text-gray-300'
          }
        >
          {message}
        </p>
        {status === 'ok' && (
          <Link
            to={LINKS.SIGNIN}
            className="inline-block mt-6 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
          >
            Go to Sign in
          </Link>
        )}
      </div>
    </div>
  );
}
